import { render, staticRenderFns } from "./offerManage.vue?vue&type=template&id=53ff8fbe&scoped=true"
import script from "./offerManage.vue?vue&type=script&lang=js"
export * from "./offerManage.vue?vue&type=script&lang=js"
import style0 from "./offerManage.vue?vue&type=style&index=0&id=53ff8fbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ff8fbe",
  null
  
)

export default component.exports